import { Drawer, Box, Typography } from "@mui/material";
import clockIcon from "../../assets/clock_img.svg";
import percentageIcon from "../../assets/percentage.svg";
import CohortDrawerContent from "../CohortDrawerContent/CohortDrawerContent";
import { MetricItem } from "./CohortMetricItem";
import CohortAudioPlayer from "../CohortAudioPlayer/CohortAudioPlayer";
import { useCohortAudioPlayer } from "../../utils/useCohortAudioPlayer";
import AnimatedGifText from "../AnimatedGifText/AnimatedGifText";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./CohortBottomDrawer.css";

const CohortBottomDrawer = ({
  open,
  onClose,
  image,
  title,
  gifText,
  gifTextArray,
  cohort,
  classNum,
  cohortDetails,
}) => {
  const { t } = useTranslationSetup();
  const [isPlaying, playAudio, stopAudio, audioRef] = useCohortAudioPlayer(
    cohort?.audio
  );

  const grade = Number(classNum);
  const ranges = cohortDetails?.rangesByGrade?.[grade] || {};
  const cwpmRange = ranges.cwpmRange || "N/A";
  const accuracyRange = ranges.accuracyRange || "N/A";

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxHeight: "90vh",
          overflow: "hidden",
          zIndex: 1,
        },
      }}
      x
    >
      <Box>
        <Box className="cohort-drawer-puller" />
        <Box
          className={`cohort-drawer-bg-color ${cohort?.className}-drawer-bg-color`}
        >
          <Box
            className={`cohort-drawer-oval-color ${cohort?.className}-oval-color`}
          >
            <Typography className="cohort-drawer-title">{title}</Typography>
            <Box
              component="img"
              src={image}
              alt={title}
              className="cohort-drawer-image"
            />
          </Box>
          <Box className="cohort-drawer-media">
            <CohortAudioPlayer
              isPlaying={isPlaying}
              playAudio={playAudio}
              stopAudio={stopAudio}
              audioRef={audioRef}
              buttonStyle={{
                backgroundColor: "#A2C357",
                minWidth: 0,
                padding: "6px",
                borderRadius: "32px",
              }}
              iconStyle={{ color: "#FFFFFF", width: "20px", height: "20px" }}
            />
            {gifTextArray && (
              <AnimatedGifText
                textArray={cohort.gifTextArray}
                pauseDuration={cohort.pauseDuration || 150}
                speed={cohort.gifSpeed}
              />
            )}
          </Box>
          <Box>
            {gifText && (
              <Typography className="cohort-drawer-gif-text">
                {cohort.gifText}
              </Typography>
            )}
          </Box>
        </Box>
        <Box className="cohort-drawer-metrics-wrapper">
          <MetricItem
            icon={clockIcon}
            label={t("cwpm_metric_range")}
            value={cwpmRange}
          />
          {/* <MetricItem
            icon={percentageIcon}
            label={t("accuracy_range")}
            value={accuracyRange}
          /> */}
          {/* <MetricItem
            icon={soundWaveIcon}
            label={t("extra_accuracy_range")}
            value={extraAccuracyRange}
          /> */}
        </Box>
        <CohortDrawerContent content={cohort?.content} />
      </Box>
    </Drawer>
  );
};

export default CohortBottomDrawer;
